/**
 * This is the entry point for all scripts. 
 * Write or import yours in this file.
 */

// helpers 
import './helpers/index.js';

// components
import "./components/accordion.js";
import "./components/images-modal.js";
import "./components/menu.js";
import "./components/swiper.js";
import "./components/vacancies.js";